import _objectSpread from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.join.js";
import { createZoneRR, deleteZoneRR as _deleteZoneRR, updateZoneRR, findZoneRR, getZoneRRList } from "@/api/zone"; //  此处请自行替换地址
import { updateDomainRemark } from "@/api/domainIndex";
import { formatTimeToStr } from "@/utils/date";
import infoList from "@/mixins/infoList";
// import queries from "@/view/zone/queries";
import HCharts from "@/components/hCharts";
import { mapGetters } from 'vuex';
export default {
  components: {
    HCharts: HCharts
  },
  name: "ZoneRR",
  mixins: [infoList],
  data: function data() {
    var _this = this;
    var checkZone = function checkZone(rule, value, callback) {
      var reg = /^(?=^.{3,228}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/;
      if (value === '') {
        callback(new Error(_this.$t('zone.checkzone-error-empty')));
      } else if (!reg.test(value)) {
        callback(new Error(_this.$t('zone.checkzone-error-invalid')));
      } else {
        callback();
      }
    };
    return {
      listApi: getZoneRRList,
      dialogFormVisible: false,
      queryVisible: false,
      type: "",
      multipleSelection: [],
      isDisabledSaveBtn: false,
      listAlias: 'zone',
      formData: {
        zone: "",
        domain_num: 0,
        soa: "",
        ttl: 0,
        ownerId: 0,
        status: false,
        isLocked: false,
        create_time: 0,
        update_time: 0
      },
      param: {},
      rules: {
        zone: [{
          required: true,
          message: this.$t('zone.checkzone-error-empty'),
          trigger: 'blur'
        }, {
          trigger: 'blur',
          validator: checkZone
        }]
      },
      addRemarkDialogFormVisible: false,
      remarkFormData: {
        remark: ""
      },
      fullscreenLoading: false
    };
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time != "") {
        var date = new Date(time * 1000);
        return formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      } else {
        return "";
      }
    },
    formatServer: function formatServer(data) {
      if (data && data.length != 0) {
        var _serverArr = [];
        data.forEach(function (res) {
          // 去掉末尾的点
          if (res.endsWith('.')) {
            res = res.substring(0, res.length - 1);
          }
          _serverArr.push(res);
        });
        return _serverArr.join('  ');
      } else {
        return "";
      }
    },
    formatDomain: function formatDomain(data) {
      if (data != "." && data.endsWith('.')) {
        return data.substring(0, data.length - 1);
      }
      return data;
    }
  },
  methods: {
    //条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      if (this.searchInfo.status == "") {
        this.searchInfo.status = null;
      }
      if (this.searchInfo.isLocked == "") {
        this.searchInfo.isLocked = null;
      }
      this.getTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    formatStatus: function formatStatus(status) {
      var info = this.$t('zone.status-warn');
      if (status == 1) {
        info = this.$t('zone.status-ok');
      } else if (status == 2) {
        info = this.$t('zone.status-pause');
      }
      return info;
    },
    deleteRow: function deleteRow(row) {
      var _this2 = this;
      this.$prompt(this.$t('zone.del-prompt-info'), this.$t('common.msg.prompt-title'), {
        confirmButtonText: this.$t('common.button.confirm'),
        cancelButtonText: this.$t('common.button.cancel'),
        inputPattern: /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/,
        inputErrorMessage: this.$t('checkzone-error-invalid')
      }).then(function (_ref) {
        var value = _ref.value;
        if (value == row.zone || value + '.' == row.zone) {
          _this2.deleteZoneRR(row);
        } else {
          _this2.$message({
            type: 'error',
            message: _this2.$t('del-check-error')
          });
        }
      });
    },
    openDomainPage: function openDomainPage(row) {
      this.$router.push({
        name: "zoneDetail",
        query: {
          zone: this.$options.filters['formatDomain'](row.zone)
        }
      });
    },
    updateZoneRR: function updateZoneRR(row) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return findZoneRR({
                ID: row.ID
              });
            case 2:
              res = _context.sent;
              _this3.type = "update";
              if (res.code == 0) {
                _this3.formData = res.data.reZone;
                _this3.dialogFormVisible = true;
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.isDisabledSaveBtn = false;
      this.formData = {
        zone: "",
        soa: "",
        ttl: 0
      };
      this.$refs['formData'].resetFields();
    },
    closeQueryDialog: function closeQueryDialog() {
      this.queryVisible = false;
    },
    deleteZoneRR: function deleteZoneRR(row) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _deleteZoneRR({
                zone: row.zone
              });
            case 2:
              res = _context2.sent;
              if (res.code == 0) {
                _this4.$message({
                  type: "success",
                  message: _this4.$t('common.msg.delete-success')
                });
                if (_this4.tableData.length == 1) {
                  _this4.page--;
                }
                _this4.getTableData();
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    enterDialog: function enterDialog(formName) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res, isOk;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              isOk = true;
              _this5.$refs[formName].validate(function (valid) {
                if (!valid) {
                  isOk = false;
                  return false;
                }
              });
              if (isOk) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return");
            case 4:
              _this5.isDisabledSaveBtn = true;
              _context3.t0 = _this5.type;
              _context3.next = _context3.t0 === "create" ? 8 : _context3.t0 === "update" ? 12 : 16;
              break;
            case 8:
              _context3.next = 10;
              return createZoneRR(_this5.formData);
            case 10:
              res = _context3.sent;
              return _context3.abrupt("break", 20);
            case 12:
              _context3.next = 14;
              return updateZoneRR(_this5.formData);
            case 14:
              res = _context3.sent;
              return _context3.abrupt("break", 20);
            case 16:
              _context3.next = 18;
              return createZoneRR(_this5.formData);
            case 18:
              res = _context3.sent;
              return _context3.abrupt("break", 20);
            case 20:
              if (res.code == 0) {
                _this5.$message({
                  type: "success",
                  message: _this5.$t('common.msg.save-success')
                });
                _this5.closeDialog();
                _this5.getTableData();
              } else {
                _this5.isDisabledSaveBtn = false;
              }
            case 21:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    openDialog: function openDialog() {
      this.type = "create";
      this.dialogFormVisible = true;
    },
    openQueryDialog: function openQueryDialog(row) {
      this.queryVisible = true;
      this.param = {
        zone: row.zone,
        showBack: false,
        showDate: false,
        showTop: true,
        teamId: this.userInfo.lastTeamId
      };
    },
    addRemark: function addRemark(row) {
      this.remarkFormData.dname = row.zone;
      this.remarkFormData.remark = row.remart;
      this.addRemarkDialogFormVisible = true;
    },
    closeAddRemarkDialog: function closeAddRemarkDialog() {
      this.addRemarkDialogFormVisible = false;
    },
    saveAddRemarkDialog: function saveAddRemarkDialog() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return updateDomainRemark(_this6.remarkFormData);
            case 2:
              res = _context4.sent;
              if (res.code == 0) {
                _this6.$message({
                  type: "success",
                  message: _this6.$t('common.msg.opt-success')
                });
                _this6.closeAddRemarkDialog();
                _this6.getTableData();
                _this6.fullscreenLoading = false;
              } else {
                _this6.isDisabledSaveBtn = false;
                _this6.fullscreenLoading = false;
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  },
  computed: _objectSpread({}, mapGetters('user', ['userInfo'])),
  created: function created() {
    var _this7 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _this7.getTableData();
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }
};